import {
  Component,
  ElementRef,
  OnInit,
  ViewChild,
  NgZone,
  HostListener,
} from "@angular/core";
import { ActivatedRoute, Router } from "@angular/router";
import { Subscription } from "rxjs";
import { Color4, Engine, Scene, Vector4 } from "babylonjs";
import { ShowProductService } from "../../services/show-product.service";
import { WalkthroughService } from "../../services/walkthrough.service";
import { WindowRefService } from "../../services/window-ref.service";
import { HttpClient } from "@angular/common/http";
import { Loading } from "../loading/Loading";
import { Title } from "@angular/platform-browser";
import { FullscreenService } from "src/app/services/fullscreen.service";
import '@google/model-viewer';

@Component({
  selector: "app-engine",
  templateUrl: "./engine.component.html",
  styleUrls: ["./engine.component.scss"],
})
export class EngineComponent implements OnInit {
  @ViewChild("rendererCanvas", { static: true })
  public rendererCanvas: ElementRef<HTMLCanvasElement>;
  private openModalRef: Subscription = null;
  private openLoad: Subscription = null;
  private engine: Engine;
  public scene: Scene;
  private canvas: HTMLCanvasElement;
  public currenItem;
  public loading = false;
  public isFullscreen = false;
  public areShowingLinks = true;
  public haveLinks = false;
  public helpOpened = false;
  public movementType;
  public client;
  //Indica si es un visualizador (true) o paseo (false)
  public viewer;
  //Indica si es el nuevo model-viewer
  public newViewer;
  public product;

  public constructor(
    private ngZone: NgZone,
    private windowRef: WindowRefService,
    private activatedRouter: ActivatedRoute,
    private router: Router,
    private walkthroughService: WalkthroughService,
    private showProductService: ShowProductService,
    private http: HttpClient,
    private titleService: Title,
    private fullscreenService: FullscreenService
  ) {}

  public ngOnInit(): void {
    // document.addEventListener("fullscreenchange", this.toogleFullscreen, false);
    // document.addEventListener(
    //   "mozfullscreenchange",
    //   this.toogleFullscreen,
    //   false
    // );
    // document.addEventListener(
    //   "MSFullscreenChange",
    //   this.toogleFullscreen,
    //   false
    // );
    // document.addEventListener(
    //   "webkitfullscreenchange",
    //   this.toogleFullscreen,
    //   false
    // );
    this.activatedRouter.queryParams.subscribe((param) => {
      if (!param["client"]) {
        this.router.navigateByUrl("not-found");
      }

      // The first step is to get the reference of the canvas element from our HTML document
      this.canvas = this.rendererCanvas.nativeElement;
      // Then, load the Babylon 3D engine:
      this.engine = new Engine(this.canvas, true, {}, true);
      this.engine.loadingScreen = new Loading("Simple");
      this.engine.displayLoadingUI();
      if (param["sceneId"]) {
        this.titleService.setTitle("CUBO | 3D Viewer");
        this.http
          .get(`./assets/configuration/${param["client"]}-products.json`)
          .subscribe((data: any) => {
            //set loading
            // create scene
            this.http
              .get(`./assets/configuration/${param["client"]}-theme.json`)
              .subscribe((data) => {
                this.changeTheme(data);
              });

            this.viewer = true;

            this.product = data.filter((s) => s.id === param["sceneId"])[0];

            this.newViewer = this.product && this.product.model_viewer;
            if (!this.newViewer){
              this.scene = this.showProductService.createScene(
                this.canvas,
                this.engine,
                param["sceneId"],
                param["embedded"],
                data
              );
              // animate
             this.animate();
            }else{
              this.engine.hideLoadingUI();
            }
            // if (this.newViewer){
            //   this.src = `./assets/products/${product.babylon}`;
            //   this.iosSrc = `./assets/products/${product.ios_src}`;


            //   this.placement = "wall";
            //   this.engine.hideLoadingUI();
            // }else{

            // }
          });
      } else {
        this.titleService.setTitle("CUBO | 360 Viewer");
        this.http
          .get(`./assets/configuration/${param["client"]}-data.json`)
          .subscribe(
            (data: any) => {
              this.http
                .get(`./assets/configuration/${param["client"]}-theme.json`)
                .subscribe((data) => {
                  this.changeTheme(data);
                });
              this.viewer = false;
              this.movementType = data.movement_type;
              this.client = data.client;
              this.helpOpened = true;
              // create scene
              this.walkthroughService.createScene(
                this.canvas,
                this.engine,
                param["environment"],
                data
              );
              this.walkthroughService.ready.subscribe((scene) => {
                this.scene = scene;
                //animate
                this.animate();
                this.haveLinks = true;
              });
              this.openModalRef = this.walkthroughService.openModal.subscribe(
                (param) => {
                  this.currenItem = param;
                }
              );
              this.openLoad = this.walkthroughService.textureLoading.subscribe(
                (param: any) => {
                  this.loading = param;
                }
              );
            },
            (error) => {
              console.error("Error found configuration");
            }
          );
      }
    });
  }
  changeTheme(theme: any) {
    theme.forEach((data) => {
      document.documentElement.style.setProperty(`${data.name}`, data.value);
    });
  }

  private animate(): void {
    // We have to run this outside angular zones,
    // because it could trigger heavy changeDetection cycles.
    this.ngZone.runOutsideAngular(() => {
      const rendererLoopCallback = () => {
        if (this.scene.isReady()) {
          this.scene.render();
          document
            .getElementById("engine-wrapper")
            .classList.remove("wrapper-hiden");
          this.engine.hideLoadingUI();
        }
      };

      if (this.windowRef.document.readyState !== "loading" && this.scene) {
        this.engine.runRenderLoop(rendererLoopCallback);
      } else {
        this.windowRef.window.addEventListener("DOMContentLoaded", () => {
          this.engine.runRenderLoop(rendererLoopCallback);
        });
      }
      this.windowRef.window.addEventListener("resize", () => {
        this.engine.resize();
      });
    });
  }
  public closeModal() {
    this.currenItem = null;
    this.helpOpened = false;
  }

  redirect() {
    window.open(this.client.url, "_blank");
  }

  public toogleFullscreen() {
    this.fullscreenService.toggle();
  }

  @HostListener("document:fullscreenchange", ["$event"])
  @HostListener("document:webkitfullscreenchange", ["$event"])
  @HostListener("document:mozfullscreenchange", ["$event"])
  @HostListener("document:MSFullscreenChange", ["$event"])
  onFullScreenChange() {
    if (this.viewer) {
      const sphere = this.scene.meshes.filter((m) => m.name === "sphere")[0];

      if (sphere) {
        if (this.fullscreenService.enabled) {
          sphere.visibility = 1;
          this.showProductService.zoom(true);
        } else {
          sphere.visibility = 0;
          this.showProductService.zoom(false);
        }
      }
    }
  }

  isInFullScreen() {
    return this.fullscreenService.enabled;
  }

  public toogleLinks() {
    this.areShowingLinks = !this.areShowingLinks;
    this.walkthroughService.toogleLinks(this.areShowingLinks, this.scene);
  }

  public toogleHelp() {
    this.helpOpened = !this.helpOpened;
  }

  
}
